module.exports = __webpack_public_path__ + "WebComponentsIcons.595e8d5c4906588d3845.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/glyphs/WebComponentsIcons.ttf?gedxeo
// module id = ../../../../../external_css/kendo-ui/fonts/glyphs/WebComponentsIcons.ttf?gedxeo
// module chunks = styles